import includes from 'lodash/includes';

/* eslint-disable no-param-reassign */
export default ({ initialData, cacheKey }) => (
  state = {
    status: 'unresolved',
    data: initialData,
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case `${cacheKey}:RESOLVED`: {
      state.data = action.payload;

      return state;
    }

    case `${cacheKey}:RESET`: {
      return {
        status: 'unresolved',
        data: null,
        error: null,
      };
    }

    case `${cacheKey}:SET`: {
      let updatedData = action.payload;

      if (action.options.setType === 'extend') {
        updatedData = { ...state.data, ...updatedData };
      }

      if (action.options.setType === 'extendRight') {
        updatedData = { ...updatedData, ...state.data };
      }

      const updatedState = { ...state, data: updatedData };

      return updatedState;
    }

    case `${cacheKey}:STATUS`: {
      if (
        !includes(
          ['unresolved', 'idle', 'loading', 'syncing', 'error', 'success'],
          action.payload,
        )
      ) { return state; }

      const updatedState = { ...state, status: action.payload };

      return updatedState;
    }

    case `${cacheKey}:FETCHED`: {
      let updatedData = action.payload.data;

      if (action.options.setType === 'extend') {
        updatedData = { ...state.data, ...updatedData };
      }

      if (action.options.setType === 'extendRight') {
        updatedData = { ...updatedData, ...state.data };
      }

      const updatedState = {
        ...state,
        response: action.payload.response,
        data: updatedData,
        status: 'success',
        error: null,
      };

      return updatedState;
    }

    case `${cacheKey}:MUTATED`: {
      let updatedData = action.payload.data;

      if (action.options.setType === 'extend') {
        updatedData = { ...state.data, ...updatedData };
      }

      if (action.options.setType === 'extendRight') {
        updatedData = { ...updatedData, ...state.data };
      }

      const updatedState = {
        ...state,
        response: action.payload.response,
        data: updatedData,
        status: 'success',
        error: null,
      };

      return updatedState;
    }

    case `${cacheKey}:ERRORED`: {
      const updatedState = {
        ...state,
        error: action.payload.error,
        response: action.payload.response,
        status: 'error',
      };

      return updatedState;
    }

    default:
      return state;
  }
};
